<template>
    <div>
        <header>
            <div class="header-title">
                <div style="display: flex; align-items: center;">
                    <p>系统配置</p>
                </div>
            </div>
        </header>
        <div class="container">
            <div style="background: #fff;padding: 20px;min-height: 700px">
                <el-table
                        :data="listData"
                        v-loading="loading"
                        :header-cell-style="tableHeaderClassName"
                        style="width: 100%">
                    <el-table-column fixed width="206" align="center">
                        <el-table-column
                                fixed
                                prop="date"
                                type="index"
                                label="序号"
                                align="center"
                                width="60px">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                fixed
                                align="center"
                                prop="moduleName"
                                label="企业库模块"
                                width="146">
                        </el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="公共资源服务">
                        <el-table-column align="center" label="自然人">
                            <el-table-column
                                    align="center"
                                    label="竞买人角色是否必填（产权）"
                                    width="129">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '国有-竞买人' && item.entType == 1">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="竞买人角色是否必填（国土）"
                                    width="129">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '国土-竞买人' && item.entType == 1">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="法人">
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="招标人角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '招标人' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="采购人角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '采购人' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="出让人角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '出让人' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="招标代理角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '招标代理' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="采购代理角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '采购代理' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="经纪代理角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '经济代理' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="投标人角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '投标单位' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="供应商角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 1 && item.roleName == '供应商' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="政务服务（中介超市服务）">
                        <el-table-column align="center" label="法人">
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="项目业主角色是否必填"
                                    width="124">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 2 && item.roleName == '项目业主' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    lprop="name"
                                    label="涉批中介角色是否必填"
                                    width="128">
                                <template scope="scope" >
                                    <div class="activeBox" v-for="(item) in scope.row.list" v-if="item.serviceType == 2 && item.roleName == '涉批中介' && item.entType == 2">
                                        <el-tooltip effect="dark" :content="item.visible == true ? '点击为不可见' : '点击为可见'" placement="top-start">
                                            <span class="activebtn" @click="visibleAction(item.id,1)">{{ item.visible == true ? '可见' : '不可见' }}</span>
                                        </el-tooltip>
                                        <span class="activeInterval"></span>
                                        <el-tooltip effect="dark" :content="item.required == true ? '点击为非必填' : '点击为必填'" placement="top-start">
                                            <span :class="item.required == true ? 'activebtn' : 'activebtn-able'" @click="visibleAction(item.id,2)">{{ item.required == true ? '必填' : '非必填' }}</span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "systemConfiguration",
        data() {
            return {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                loading:true,
                listData:[],
            }
        },
        created() {
            this.queryList();
        },
        activated() {
            this.queryList();
        },
        methods: {
            // 查询
            queryList(){
                this.$http.get('/ent-setting').then((res) => {
                    if(res.data && res.data.code == 1){
                        this.listData = res.data.data;
                    }
                    this.loading = false;
                });
            },
            // 操作 (type为1控制是否可见,type为2控制是否必填
            visibleAction(id,type){
                this.$http.put(`/ent-setting/${id}/${type}`).then((res) => {
                    if(res.data && res.data.code ==1){
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                    this.queryList()
                });
            },
            // 改变表头的背景色
            tableHeaderClassName(obj) {
                if(obj.rowIndex == 0 && (obj.columnIndex == 1 || obj.columnIndex == 2)){
                    return 'background-color: #fff;color: #000000;font-size: 14px;'
                }else if(obj.rowIndex == 0 && obj.columnIndex == 0){
                    return 'background-color: #fff;color: #000000;font-size: 14px; border-right: none;'
                }else if(obj.rowIndex == 1 && (obj.columnIndex == 0 || obj.columnIndex == 1)){
                    return 'background-color: #EFF3F6;color: #000000;font-size: 14px;'
                }else if(obj.rowIndex == 1 && obj.columnIndex == 2){
                    return 'background-color: rgb(255, 241, 220,0.5);;color: #000000;font-size: 14px;'
                }else if(obj.rowIndex == 1 && obj.columnIndex == 3){
                    return 'background-color: rgb(236, 245, 255,0.5);;color: #000000;font-size: 14px;'
                }else if(obj.rowIndex == 1 && obj.columnIndex == 4){
                    return 'background-color: rgb(232, 244, 227,0.5);;color: #000000;font-size: 14px;'
                }else if(obj.rowIndex == 2 && (obj.columnIndex == 0 || obj.columnIndex == 1)){
                    return 'background-color: #FFF1DC;;color: #000000;font-size: 14px;'
                }else if(obj.rowIndex == 2 && (obj.columnIndex == 10 || obj.columnIndex == 11)){
                    return 'background-color: #E8F4E3;;color: #000000;font-size: 14px;'
                }else{
                    return 'background-color: #ECF5FF;;color: #000000;font-size: 14px;'
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    header{
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        .header-title {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 0 0;
            p {
                font-size: 18px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-left: 32px;
            }
        }
    }
    .container{
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
        margin-top: 20px;
        .activeBox{
            display: flex;
            align-items: center;
            justify-content: space-around;
            .activebtn{
                width: 42px;
                cursor: pointer;
                font-size: 14px;
                color: #1890FF;
            }
            .activebtn-able{
                width: 42px;
                cursor: pointer;
                font-size: 14px;
                color: #1890FF;
                opacity: 0.25;
            }
            .activeInterval{
                width: 1px;
                height: 14px;
                background: rgba(0, 0, 0, 0.08);
            }
        }
        .card-content-search{
            display: flex;
            justify-content: flex-end;
            padding: 10px 0 20px;
            .card-content-search-add {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
            }
        }
    }
</style>